import { FC, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { hasAccessToThis } from 'services/Utilities'
import { createErrorNotification } from 'store/actions/notifications'
import { AttendanceItem } from 'components/Items'
import { Alert } from 'ui'
import useApi from 'components/Hooks/useApi'

import { t } from 'translations'

type Props = {
  currentUserId: string
  requestTypeId: number
}

const AbsenceBank: FC<Props> = ({ currentUserId, requestTypeId }) => {
  const dispatch = useDispatch()
  const { absenceBankEnabled, absenceBankPeriod } = useSelector((state: MStore.RootState) => state.settings)
  const { userInfo } = useSelector((state: MStore.RootState) => state.users)
  const userId = userInfo?._id
  const [absenceThresholdReached, setAbsenceThreshold] = useState(false)
  const [absenceBank, setAbsenceBank] = useState<MData.Attendance[]>([])

  const { handleApi: fetchAllAbsences } = useApi({ method: 'GET', url: `/requests/leave/bank?userId=${currentUserId}` })

  useEffect(() => {
    const canLoadAbsenceBank = hasAccessToThis('attendanceSeeOthers') || currentUserId === userId
    async function loadAttendanceBank() {
      const { response, isError }: { response: { absenceThresholdReached: boolean; absences: MData.Attendance[] } | null; isError: boolean } =
        await fetchAllAbsences()
      const { absenceThresholdReached, absences } = response || {}
      if (isError) return dispatch(createErrorNotification())
      if (!response) return
      setAbsenceThreshold(absenceThresholdReached || false)
      setAbsenceBank(absences || [])
    }

    if (requestTypeId !== 1) setAbsenceBank([])
    else if (currentUserId && currentUserId !== '' && canLoadAbsenceBank && absenceBankEnabled) loadAttendanceBank()
  }, [absenceBankEnabled, dispatch, currentUserId, requestTypeId, userId, fetchAllAbsences])

  if (!absenceBankEnabled || !absenceBank.length) return null

  return (
    <Alert variant={absenceThresholdReached && absenceBankPeriod ? 'danger' : 'warning'}>
      <>
        <div className="mb-2">
          <h5 className="mb-0">
            {t(`manager.attendances.${currentUserId === userId ? 'TOTAL_ABSENCES_IN_BANK_MY_HOME' : 'TOTAL_ABSENCES_IN_BANK'}`, {
              period: absenceBankPeriod,
              totalAbsences: absenceBank.length
            })}
          </h5>
          {absenceThresholdReached ? <i>{t('manager.attendances.THIS_ABSENCE_WILL_BE_OVER_THRESHOLD')}</i> : null}
        </div>
        {absenceBank.map(absence => (
          <div key={absence._id}>
            <AttendanceItem attendance={absence} />
          </div>
        ))}
      </>
    </Alert>
  )
}

export default AbsenceBank
